import React, { useState } from 'react';
import { login, resetRequest, resetConfirm } from '../auth';

export default function Login({ onLogin }) {
  const [mode, setMode] = useState('login'); // login | reset-request | reset-confirm
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const data = await login(email, password);
      onLogin(data.token, data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  }

  async function handleResetRequest(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await resetRequest(email);
      setSuccess(`A reset code has been sent to ${email}`);
      setMode('reset-confirm');
    } catch {
      setError('Failed to send reset code');
    } finally { setLoading(false); }
  }

  async function handleResetConfirm(e) {
    e.preventDefault();
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true); setError('');
    try {
      await resetConfirm(email, code, newPassword);
      setSuccess('Password reset successfully. You can now log in.');
      setMode('login');
      setCode(''); setNewPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired code');
    } finally { setLoading(false); }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">✉</div>
        <h1 className="login-title">FlexiSupport Mail</h1>
        <p className="login-subtitle">central@flexisupport.com.au</p>

        {success && <div className="login-success">{success}</div>}
        {error && <div className="login-error">{error}</div>}

        {mode === 'login' && (
          <form onSubmit={handleLogin} className="login-form">
            <div className="login-field">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
            <button type="button" className="login-link" onClick={() => { setMode('reset-request'); setError(''); setSuccess(''); }}>
              Forgot password?
            </button>
          </form>
        )}

        {mode === 'reset-request' && (
          <form onSubmit={handleResetRequest} className="login-form">
            <p className="login-hint">Enter your email and we'll send you a reset code.</p>
            <div className="login-field">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset code'}
            </button>
            <button type="button" className="login-link" onClick={() => { setMode('login'); setError(''); setSuccess(''); }}>
              Back to sign in
            </button>
          </form>
        )}

        {mode === 'reset-confirm' && (
          <form onSubmit={handleResetConfirm} className="login-form">
            <p className="login-hint">Enter the 6-digit code sent to your email and choose a new password.</p>
            <div className="login-field">
              <label>Reset code</label>
              <input value={code} onChange={e => setCode(e.target.value)} placeholder="123456" required autoFocus maxLength={6} />
            </div>
            <div className="login-field">
              <label>New password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
            <button type="button" className="login-link" onClick={() => { setMode('login'); setError(''); setSuccess(''); }}>
              Back to sign in
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
